// Set iframe src dynamically to avoid hardcoded absolute URL
function initGTMIframe() {
  const gtmIframeConfig = window.GTM_CONFIG;
  const iframe = document.getElementById('gtm-noscript-iframe');
  if (iframe && gtmIframeConfig) {
    iframe.src = gtmIframeConfig.baseUrl + '/ns.html?id=' + gtmIframeConfig.containerId;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGTMIframe);
} else {
  initGTMIframe();
}